const store = {
    namespaced: true,
    state() {
        return {
            isOpen: false,
            announcements: [],
            features: [],
            currencies: [],
        }
    },
    getters: {
        isOpen: (state) => state.isOpen,
        announcements: (state) => state.announcements,
        features: (state) => state.features,
        currencies: (state) => state.currencies,
    },
    mutations: {
        SET_IS_OPEN: (state, flag) => state.isOpen = flag,
        GET_ANNOUNCEMENTS: (state, items) => state.announcements = items,
        SET_FEATURES: (state, items) => state.features = items,
        GET_CURRENCIES: (state, items) => state.currencies = items,
        GET_FEATURES: (state, items) => {
            if (items.length) {
                items = items.map(i => {
                    return {
                        ...i,
                        checked: false,
                    }
                })
            }
            state.features = items
        },
    },
    actions: {
        setIsOpen: ({ commit }, flag) => commit('SET_IS_OPEN', flag),
        setFeatures: ({ commit }, items) => commit('SET_FEATURES', items),
        fetchAdditionalsFeatures: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'GET',
                    url: `/api/adverts-attributes/`,
                })
                commit('GET_FEATURES', res.data)
            } catch (error) {
                console.dir(error)
            }
        },
        fetchCurrencies: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'GET',
                    url: `/api/currency-rates/`,
                })
                commit('GET_CURRENCIES', res.data)
            } catch (error) {
                console.dir(error)
            }
        },
        addAnnouncement: async function ({ dispatch }, data) {
            const requestType = data.isEditing ? 'PATCH' : 'POST'
            let theContacts, theAttributes, theImages = ''
            let imagesToDelete = []
            let attributesToDelete = []
            const rawImages = data.images ? [...data.images] : []

            if (data.isEditing) {
                theContacts = 'new_contacts'
                theAttributes = 'new_attributes'
                theImages = 'new_images'
            } else {
                theContacts = 'contacts'
                theAttributes = 'attributes'
                theImages = 'images'
            }

            // ADD|DELETE IMAGES ON EDITING
            if (data.isEditing) {
                const deletedImages = data.temporaryImages ? data.temporaryImages
                    .filter(tempImage => tempImage.id !== null && !data.images.some(image => image.id === tempImage.id))
                    .map(tempImage => tempImage.id) : []

                const newImages = data.images ? data.images.filter(image => image.file !== null) : []

                data.images = newImages
                imagesToDelete = deletedImages
            }

            // ADD|DELETE IMAGES ON EDITING
            if (data.isEditing) {
                const deletedAttributes = data.temporaryAttributes ? data.temporaryAttributes
                    .filter(tempAttr => !data.attributes.includes(tempAttr.id))
                    .map(tempAttr => tempAttr.id) : []
                attributesToDelete = deletedAttributes
            }

            let form = new FormData()

            if (data.type) form.append('type', data.type)
            if (data.title_ro) form.append('title_ro', data.title_ro)
            if (data.title_ru) form.append('title_ru', data.title_ru)
            if (data.description_ro) form.append('description_ro', data.description_ro)
            if (data.description_ru) form.append('description_ru', data.description_ru)
            if (data.price) form.append('price', data.price)
            if (data.default_currency) form.append('default_currency', data.default_currency)
            if (data.area) form.append('area', data.area)
            if (data.default_area_unit) form.append('default_area_unit', data.default_area_unit)
            if (data.lat) form.append('lat', data.lat)
            if (data.lon) form.append('lon', data.lon)
            form.append('is_active', data.is_active)
            form.append('is_draft', data.is_draft)
            form.append('is_negotiable_price', data.is_negotiable_price)
            if (data.region) form.append('region', data.region)
            if (data.location) form.append('location', data.location)
            if (data.sector) form.append('sector', data.sector)
            if (data.address) form.append('address', data.address)
            if (data.category) form.append('category', data.category)
            if (data.attributes?.length) form.append(theAttributes, data.attributes)
            if (data.contacts?.length) form.append(theContacts, data.contacts)
            if (data.images?.length) {
                data.images.forEach(file => {
                    form.append(theImages, file.file)
                })
            }
            if (imagesToDelete.length) form.append('images_to_delete', imagesToDelete)
            if (attributesToDelete.length) form.append('attributes_to_delete', attributesToDelete)
            if (data.cadastral_number) form.append('cadastral_number', data.cadastral_number)

            // CERTAIN PREVIEW IMAGE
            if (data.isEditing && rawImages && rawImages.length) {
                if (rawImages[0].file) {
                    form.append('image_preview', JSON.stringify({
                        source: 'new_images',
                        id: null,
                    }))
                } else {
                    form.append('image_preview', JSON.stringify({
                        source: 'old_images',
                        id: rawImages[0].id,
                    }))
                }
            }
            
            const res = await this.$axios({
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                method: requestType,
                url: `/api/adverts/${data.editingSlug ? data.editingSlug + '/' : ''}`,
                data: form
            })

            if (!data.is_draft && !data.isEditing) {
                // this.$router.push({ path: this.localePath(`/post/${res.data.slug}`) })
                this.dispatch('modals/open', this.state.modals.modalsNames.ADD_ANNOUNCEMENT_SUCCESS)
            }
        },
    }
}

export default store
